import React, { useContext } from "react"

import Nav from "~tailwindui/Nav"

import classNames from "src/classNames"

import UnreadBadge from "components/Messaging/UnreadBadge"

import TutorContext from "./TutorContext"
import { path } from "./TutorRoutes"

export type TutorNavProps = {
  logout: () => void
}

const TutorNav: React.FC<TutorNavProps> = ({ logout }) => {
  const { viewer, unreadMessageCount } = useContext(TutorContext)

  const navItems = [
    { name: "Home", path: path("dashboard") },
    { name: "Sessions", path: path("sessionsIndex") },
    { name: "Study Groups", path: path("studyGroupsIndex") },
    { name: "Students", path: path("studentsIndex") },
    viewer.messagingDisabled
      ? null
      : {
          name: (
            <div
              className={classNames(
                "flex w-full items-center",
                unreadMessageCount > 0 && "font-bold"
              )}
            >
              <span>Messages</span>
              <UnreadBadge count={unreadMessageCount} />
            </div>
          ),
          path: path("messageThreadsIndex"),
        },
  ].filter(Boolean)

  return (
    <Nav
      navItems={navItems}
      viewer={viewer}
      profilePath={path("profileEdit")}
      logout={logout}
    />
  )
}

export default TutorNav
